<template>
  <div v-if="selectedMasterClass && isOpen">
    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="vuemodal">
      <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-sell" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>
                  Cancellation Policy ({{
                    selectedMasterClass.masterClassName
                  }})
                </h4>
                <h6 v-if="timestampItem">Last Updated: {{ timestampItem }}</h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="onCloseModal()"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper modal-detail">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <div class="summary-error" v-if="$v.model.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submit">
                    <div class="row">
                      <!-- Start: Form -->
                      <div
                        :class="
                          serviceType === 1
                            ? 'col-sm-3 divider-right pr-25'
                            : 'col-sm-4 divider-right pr-25'
                        "
                      >
                        <template v-if="serviceType === 1">
                          <div class="form-group">
                            <label class="required"
                              >Range of Hour (start)</label
                            >
                            <input
                              class="form-control"
                              :class="{
                                'field-error':
                                  isSubmitted &&
                                  $v.model.startHourBeforePickup.$error,
                              }"
                              type="number"
                              v-model="model.startHourBeforePickup"
                            />
                            <div
                              v-if="
                                isSubmitted &&
                                $v.model.startHourBeforePickup.$error
                              "
                            >
                              <small
                                class="form-text sts-danger"
                                v-if="!$v.model.startHourBeforePickup.required"
                              >
                                Range start is required
                              </small>
                              <small
                                class="form-text sts-danger"
                                v-if="!$v.model.startHourBeforePickup.minValue"
                              >
                                Min hour is
                                {{
                                  $v.model.startHourBeforePickup.$params
                                    .minValue.min
                                }}
                              </small>
                            </div>
                          </div>
                          <div class="form-group">
                            <label class="required">Range of Hour (end)</label>
                            <input
                              class="form-control"
                              :class="{
                                'field-error':
                                  isSubmitted &&
                                  $v.model.endHourBeforePickup.$error,
                              }"
                              type="number"
                              v-model="model.endHourBeforePickup"
                              :disabled="model.endHourBeforePickupIsInfinite"
                            />
                            <label class="cursor-pointer">
                              <input
                                type="checkbox"
                                class="control-checkbox"
                                v-model="model.endHourBeforePickupIsInfinite"
                                @change="changeInfinite()"
                              />
                              <span
                                class="pl-5 font-weight-normal v-align-middle"
                              >
                                Infinite
                              </span>
                            </label>
                            <div
                              v-if="
                                isSubmitted &&
                                $v.model.endHourBeforePickup.$error
                              "
                            >
                              <small
                                class="form-text sts-danger"
                                v-if="!$v.model.endHourBeforePickup.required"
                              >
                                Range end is required
                              </small>
                            </div>
                          </div>
                        </template>
                        <template v-else>
                          <div class="form-group">
                            <label class="required">If cancelled between</label>
                            <div class="row">
                              <div class="col-sm-6">
                                <input
                                  class="form-control"
                                  :class="{
                                    'field-error':
                                      isSubmitted &&
                                      $v.model.startHourBeforePickup.$error,
                                  }"
                                  type="number"
                                  v-model="model.startHourBeforePickup"
                                />
                                <label class="cursor-pointer">
                                  <span
                                    class="font-weight-normal v-align-middle"
                                  >
                                    Hours before pick-up time
                                  </span>
                                </label>
                                <div
                                  v-if="
                                    isSubmitted &&
                                    $v.model.startHourBeforePickup.$error
                                  "
                                >
                                  <small
                                    class="form-text sts-danger"
                                    v-if="
                                      !$v.model.startHourBeforePickup.required
                                    "
                                  >
                                    Range start is required
                                  </small>
                                  <small
                                    class="form-text sts-danger"
                                    v-if="
                                      !$v.model.startHourBeforePickup.minValue
                                    "
                                  >
                                    Min hour is
                                    {{
                                      $v.model.startHourBeforePickup.$params
                                        .minValue.min
                                    }}
                                  </small>
                                </div>
                              </div>
                              <div class="col-sm-6">
                                <input
                                  class="form-control"
                                  :class="{
                                    'field-error':
                                      isSubmitted &&
                                      $v.model.endHourBeforePickup.$error,
                                  }"
                                  type="number"
                                  v-model="model.endHourBeforePickup"
                                  :disabled="
                                    model.endHourBeforePickupIsInfinite
                                  "
                                />
                                <label class="cursor-pointer">
                                  <input
                                    type="checkbox"
                                    class="control-checkbox"
                                    v-model="
                                      model.endHourBeforePickupIsInfinite
                                    "
                                    @change="changeInfinite()"
                                  />
                                  <span
                                    class="pl-5 font-weight-normal v-align-middle"
                                  >
                                    Infinite
                                  </span>
                                </label>
                                <div
                                  v-if="
                                    isSubmitted &&
                                    $v.model.endHourBeforePickup.$error
                                  "
                                >
                                  <small
                                    class="form-text sts-danger"
                                    v-if="
                                      !$v.model.endHourBeforePickup.required
                                    "
                                  >
                                    Range end is required
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                        <div class="form-group">
                          <label class="required">
                            Charge Amount per Hour
                            <span class="--grey50">(%)</span>
                          </label>
                          <input
                            class="form-control"
                            :class="{
                              'field-error':
                                isSubmitted && $v.model.percentageCharge.$error,
                            }"
                            type="number"
                            v-model="model.percentageCharge"
                            step="any"
                          />
                          <div
                            v-if="
                              isSubmitted && $v.model.percentageCharge.$error
                            "
                          >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.percentageCharge.required"
                              >Rate is required</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.percentageCharge.minValue"
                              >Min percentage is
                              {{
                                $v.model.percentageCharge.$params.minValue.min
                              }}</small
                            >
                          </div>
                        </div>
                        <div class="form-group" v-if="serviceType === 2">
                          <label class="required"
                            >Maximum No. of Hours Charged</label
                          >
                          <input
                            class="form-control"
                            :class="{
                              'field-error':
                                isSubmitted &&
                                $v.model.maximumChargeHour.$error,
                            }"
                            type="number"
                            v-model="model.maximumChargeHour"
                            :disabled="model.maximumChargeHourIsInfinite"
                          />
                          <label class="cursor-pointer">
                            <input
                              type="checkbox"
                              class="control-checkbox"
                              v-model="model.maximumChargeHourIsInfinite"
                              @change="changeMaxChargeHoursInInfinite()"
                            />
                            <span
                              class="pl-5 font-weight-normal v-align-middle"
                            >
                              Full Booking Period
                            </span>
                          </label>
                          <div
                            v-if="
                              isSubmitted && $v.model.maximumChargeHour.$error
                            "
                          >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.maximumChargeHour.required"
                            >
                              Range end is required
                            </small>
                          </div>
                        </div>
                        <div
                          class="modal-footer"
                          v-if="isAllowToCreate || isAllowToUpdate"
                        >
                          <button
                            type="button"
                            class="btn btn-default"
                            @click.prevent="onResetForm()"
                          >
                            Reset
                          </button>
                          <button
                            v-if="!isUpdate && isAllowToCreate"
                            type="button"
                            class="btn btn-primary"
                            @click.prevent="onSubmitForm()"
                          >
                            Create
                          </button>
                          <button
                            v-if="isUpdate && isAllowToUpdate"
                            type="button"
                            class="btn btn-primary"
                            @click.prevent="onSubmitForm()"
                          >
                            Update
                          </button>
                        </div>
                      </div>
                      <!-- End: Form -->
                      <!-- Start: Table -->
                      <div
                        :class="
                          serviceType === 1
                            ? 'col-sm-9 divider-left pl-20'
                            : 'col-sm-8 divider-left pl-20'
                        "
                      >
                        <div class="table-modal-detail">
                          <div class="table-responsive table-accordion">
                            <table class="table table-hover">
                              <thead>
                                <tr>
                                  <th class="number">No</th>
                                  <th>Range of Hour</th>
                                  <th
                                    class="text-right"
                                    style="padding: 15px 0"
                                  >
                                    Charge Amount per Hour (%)
                                  </th>
                                  <th
                                    class="text-center"
                                    v-if="serviceType === 2"
                                  >
                                    Maximum No. of Hours Charged
                                  </th>
                                  <th class="text-center">Status</th>
                                  <th class="text-center">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(item, index) in items"
                                  :key="item.id"
                                >
                                  <td class="text-center">{{ index + 1 }}</td>
                                  <td style="padding: 15px 10px">
                                    {{
                                      $helper.printRangeOfHour(
                                        item.startHourBeforePickup,
                                        item.endHourBeforePickup
                                      )
                                    }}
                                  </td>
                                  <td class="text-right">
                                    {{ item.percentageCharge }}
                                  </td>
                                  <td
                                    class="text-center"
                                    v-if="serviceType === 2"
                                  >
                                    {{
                                      item.maximumChargeHour === null
                                        ? "-"
                                        : item.maximumChargeHour < 0
                                        ? "Full of Booking Hour"
                                        : item.maximumChargeHour
                                    }}
                                  </td>
                                  <td class="text-center">
                                    <label class="cursor-pointer">
                                      <input
                                        type="checkbox"
                                        class="control-checkbox"
                                        v-model="item.isActive"
                                        :disabled="!isAllowToUpdate"
                                        @change="onChangeStatus(item)"
                                      />
                                      <span
                                        class="pl-5 font-weight-normal v-align-middle"
                                      >
                                        {{
                                          item.isActive ? "Active" : "Inactive"
                                        }}
                                      </span>
                                    </label>
                                  </td>
                                  <td class="text-center">
                                    <div class="button-action-wrapper">
                                      <button
                                        v-if="isAllowToUpdate"
                                        class="btn btn-default"
                                        type="button"
                                        @click="onEdit(item)"
                                      >
                                        <span>Edit</span>
                                      </button>
                                      <button
                                        v-if="isAllowToDelete"
                                        class="btn btn-default"
                                        type="button"
                                        @click="onDelete(item)"
                                      >
                                        <i class="ic-close"></i>
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <!-- End: Table -->
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
          <!-- /.modal-body -->
        </div>
        <!-- /.modal-content -->
      </div>
    </div>

    <deleteModal @submit="submitDelete" @cancel="cancelDelete" />
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required, minValue } from "vuelidate/lib/validators";
import deleteModal from "@/components/shared/DeleteModal";
import sellingTariffCancellationSurchargeService from "@/services/master/sellingTariff/sellingTariffCancellationSurchargeService.js";

const defaultModel = {
  id: null,
  masterClassId: null,
  startHourBeforePickup: null,
  endHourBeforePickup: null,
  endHourBeforePickupIsInfinite: false,
  maximumChargeHour: null,
  maximumChargeHourIsInfinite: null,
  totalHourBeforePickup: null,
  percentageCharge: null,
  isActive: true,
};

export default {
  components: {
    deleteModal,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
    validationRuleEndOfRangeHour: function () {
      return this.model && this.model.endHourBeforePickupIsInfinite
        ? {}
        : { required };
    },
    validationRuleMaximumChargeHour: function () {
      return this.model && this.model.maximumChargeHourIsInfinite
        ? {}
        : { required, minValue: minValue(0) };
    },
  },
  props: ["serviceType"],
  data() {
    return {
      isSubmitted: false,
      isOpen: false,
      allPermissions: [],
      selectedMasterClass: null,
      formatter: null,
      moneyFormat: null,
      timestampItem: null,
      itemIdToBeDeleted: null,
      items: [],
      model: {},
      isUpdate: false,
      isLoading: false,
      msg: "Please wait",
    };
  },
  validations() {
    const v = {
      model: {
        startHourBeforePickup: { required, minValue: minValue(0) },
        endHourBeforePickup: this.validationRuleEndOfRangeHour,
        percentageCharge: { required, minValue: minValue(0) },
        maximumChargeHour: {},
      },
    };

    if (this.serviceType === 2) {
      v.model = {
        startHourBeforePickup: { required, minValue: minValue(0) },
        endHourBeforePickup: this.validationRuleEndOfRangeHour,
        percentageCharge: { required, minValue: minValue(0) },
        maximumChargeHour: this.validationRuleMaximumChargeHour,
      };
    }

    return v;
  },
  created() {
    this.$eventBus.$on(
      "initializeSellingTariffCancellationSurcharge",
      this.initialize
    );
  },
  beforeDestroy() {
    this.$eventBus.$off("initializeSellingTariffCancellationSurcharge");
  },
  methods: {
    async initialize(masterClass, moneyFormat, formatter) {
      try {
        this.isLoading = true;
        this.isOpen = true;
        this.selectedMasterClass = masterClass;
        this.moneyFormat = moneyFormat;
        this.formatter = formatter;

        const profile = await this.$store.dispatch("user/getProfile");
        const permissions =
          profile.services["SellingTariffCancellationSurcharge"];
        if (permissions) {
          this.allPermissions = permissions;
        }

        if (this.isAllowToRead) {
          this.getAll().then(() => {
            $(this.$refs.vuemodal).modal({
              backdrop: "static",
              keyboard: false,
            });
            this.onResetForm();
          });
        }
      } finally {
        this.isLoading = false;
      }
    },
    onResetForm() {
      this.isUpdate = false;
      this.timestampItem = null;
      this.clearValidation();
      this.model = Object.assign({}, defaultModel);
    },
    clearValidation() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    bindModel(item) {
      this.model.id = item.id;
      this.model.masterClassId = item.masterClassId;
      this.model.startHourBeforePickup = item.startHourBeforePickup;
      this.model.maximumChargeHour = item.maximumChargeHour;
      this.model.totalHourBeforePickup = item.totalHourBeforePickup;
      this.model.percentageCharge = item.percentageCharge;
      this.model.isActive = item.isActive;

      if (
        item.endHourBeforePickup === -1 ||
        item.endHourBeforePickup === null
      ) {
        this.model.endHourBeforePickupIsInfinite = true;
        this.model.endHourBeforePickup = null;
      } else {
        this.model.endHourBeforePickupIsInfinite = false;
        this.model.endHourBeforePickup = item.endHourBeforePickup;
      }

      if (item.maximumChargeHour === -1 || item.maximumChargeHour === null) {
        this.model.maximumChargeHourIsInfinite = true;
        this.model.maximumChargeHour = null;
      } else {
        this.model.maximumChargeHourIsInfinite = false;
        this.model.maximumChargeHour = item.maximumChargeHour;
      }
    },
    onCloseModal() {
      this.isOpen = false;
      $(this.$refs.vuemodal).modal("hide");
    },
    onEdit(item) {
      this.isUpdate = true;
      this.timestampItem = item.modifiedDate.stringFullDate;
      this.bindModel(item);
    },
    onDelete(item) {
      this.itemIdToBeDeleted = item.id;
      $("#deletemodal").modal();
    },
    constructPayload() {
      const payload = Object.assign({}, defaultModel);

      if (this.isUpdate) {
        payload.id = this.model.id;
        payload.isActive = this.model.isActive;
      }

      payload.masterClassId = this.selectedMasterClass.masterClassId;
      payload.startHourBeforePickup = this.model.startHourBeforePickup;
      payload.maximumChargeHour = this.model.maximumChargeHour;
      payload.totalHourBeforePickup = this.model.totalHourBeforePickup;
      payload.percentageCharge = this.model.percentageCharge;
      payload.serviceType = this.serviceType;
      payload.endHourBeforePickupIsInfinite =
        this.model.endHourBeforePickupIsInfinite;
      payload.maximumChargeHourIsInfinite =
        this.model.maximumChargeHourIsInfinite;

      if (this.model.endHourBeforePickupIsInfinite) {
        payload.endHourBeforePickup = -1;
      } else {
        payload.endHourBeforePickup = this.model.endHourBeforePickup;
      }

      if (this.model.maximumChargeHourIsInfinite) {
        payload.maximumChargeHour = -1;
      } else {
        payload.maximumChargeHour = this.model.maximumChargeHour;
      }

      return payload;
    },
    async getAll() {
      this.items = await sellingTariffCancellationSurchargeService.getAll(
        this.selectedMasterClass.masterClassId,
        this.serviceType
      );
    },
    async submitDelete() {
      try {
        this.isLoading = true;
        await sellingTariffCancellationSurchargeService.delete(
          this.itemIdToBeDeleted
        );
        this.itemIdToBeDeleted = null;

        this.getAll().then(() => {
          this.$notification.success("Successfully deleted.", {
            title: "Success",
          });
        });
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
        setTimeout(() => {
          $("body").addClass("modal-open");
        }, 500);
      }
    },
    cancelDelete() {
      setTimeout(() => {
        $("body").addClass("modal-open");
      }, 500);
    },
    async onSubmitForm() {
      this.isSubmitted = true;
      this.$v.model.$touch();

      if (this.$v.model.$error) {
        return;
      }

      try {
        this.isLoading = true;
        const payload = this.constructPayload();
        if (this.isUpdate) {
          await this.submitUpdate(payload);
        } else {
          await this.submitCreate(payload);
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async onChangeStatus(item) {
      this.isLoading = true;
      this.isUpdate = true;
      this.bindModel(item);
      this.model.isActive = !!this.model.isActive;

      try {
        const payload = this.constructPayload();
        await this.submitUpdate(payload);
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async submitCreate(payload) {
      await sellingTariffCancellationSurchargeService.create(payload);
      this.onResetForm();

      this.getAll().then(() => {
        this.$notification.success("Successfully created.", {
          title: "Success",
        });
      });
    },
    async submitUpdate(payload) {
      await sellingTariffCancellationSurchargeService.update(payload);
      this.onResetForm();

      this.getAll().then(() => {
        this.$notification.success("Successfully updated.", {
          title: "Success",
        });
      });
    },
    changeInfinite() {
      this.model.endHourBeforePickup = null;
    },
    changeMaxChargeHoursInInfinite() {
      this.model.maximumChargeHour = null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/master/sellingTariff/CancellationSurcharge.vue